<template lang="pug">
  .tag-list
    .tag-list--big
      tag-item(
        v-for='tag in tagList',
        :key='tag.id',
        :text='tag.name',
        :id='tag.id'
      )
    .tag-list--small
      tag-item(
        v-for='tag in tagList',
        :key='tag.id',
        :text='tag.name.substr(0, 3)',
        :id='tag.id'
      )
</template>

<script>
import TagItem from '@/components/TagItem'
import { mapGetters } from 'vuex'

export default {
  components: {
    TagItem
  },
  computed: {
    ...mapGetters('tag', [
      'tagList',
      'selectedTagId'
    ])
  }
}
</script>

<style scoped>
.tag-list--big, .tag-list--small {
  display: flex;
  justify-content: center;
}
.tag-list--big {
  flex-direction: column;
}
.tag-list--small {
  flex-direction: row;
}
.tag-list {
  position: absolute;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@media only screen and (min-width: 600px) {
  .tag-list {
    top: 50%;
    right: 2px;
    transform: translate(0, -50%);
  }
  .tag-list--small {
    display: none;
  }
}
@media only screen and (max-width: 600px) {
  .tag-list {
    left: 50%;
    bottom: 2px;
    transform: translate(-50%, 0);
  }
  .tag-list--big {
    display: none;
  }
}
</style>
